import { APP_LOCALE, setI18nLocale } from '@/i18n';
import { defineStore } from 'pinia';
import { isSupportedLang } from '@/utils/lib/i18nUtils';
import type { Locale } from '@/i18n';
import type { Writeable } from '@/utils';

export const useI18nStore = defineStore({
  id: 'i18n',
  state: (): Writeable<{ readonly locale: Locale }> => ({
    locale: process.env.VUE_APP_I18N_LOCALE as Locale
  }),
  actions: {
    set(locale: Locale): void {
      if (!isSupportedLang(locale)) throw new Error(`Trying to set unsupported language locale: ${locale}`);
      setI18nLocale(locale);
      sessionStorage.setItem(APP_LOCALE, locale);
      this.locale = locale;
    }
  }
});
